import env from "Consts/env";
import { apiSlice } from "../api/apiSlice";

export const categoryApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCategoryList: builder.query({
			query: (args) => ({
				url: `/api/fds-category/${args.placement}`,
				headers: {
					...env.HEADERS,
				},
				params: {},
				transformResponse: (response) => ({
					status: response?.status ?? response.meta.code, data: response,
				}),
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			// providesTags: ["Products"],
		}),
		getCategoryDetail: builder.query({
			query: (args) => ({
				url: `/api/fds-category/${args.params?.slug}`,
				headers: {
					...env.HEADERS,
				},
				params: {},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			// providesTags: ["Products"],
		}),
		getCategoryPopup: builder.query({
			query: () => ({
				url: "/api/popupCategory",
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			providesTags: ["PopupCategory"],
		}),
	}),
});

export const {
	useGetCategoryListQuery,
	useGetCategoryDetailQuery,
} = categoryApiSlice;
